"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("@lingui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _reactRouterDom = require("react-router-dom");

var _reactHotLoader = require("react-hot-loader");

var _reactRouter = require("react-router");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _blocks = require("@bueno/blocks");

var _Page = require("../../components/Layout/Page");

var _actionCreators = require("../../redux/modules/urlHistory/actionCreators");

var _issues = require("../../redux/modules/_BETA/issues");

var _selections = require("../../redux/modules/_BETA/selections");

var _Issues = require("../../components/Issues");

var _Loading = _interopRequireDefault(require("../../components/Loading"));

var _requestSchedule = require("../../redux/modules/_BETA/requestSchedule");

var _context = require("../../components/ActionModals/ViewAction/context");

const ActionsContainer = _styledComponents.default.div`
  position: relative;
`;
const ReloaderContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.4);
`;

function mapStateToProps(state) {
  return {
    appSetupComplete: state.appSetup.appSetupComplete,
    user: state.auth.user,
    error: state.betaIssues.error,
    data: state.betaIssues.data,
    issuesLoaded: state.betaIssues.loaded,
    issuesLoading: state.betaIssues.loading,
    sortFilter: state.betaActionsUI.sortFilter,
    sortDirection: state.betaActionsUI.sortDirection,
    shouldRequestIssues: state.requestSchedule.shouldRequestIssues,
    urlHistory: state.urlHistory,
    selectedSites: state.betaSelections.selectedSites
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return { ...(0, _redux.bindActionCreators)({
      updateBetaIssue: _issues.updateBetaIssue,
      loadIssuesRequest: _issues.loadIssuesRequest,
      setShouldRequestIssues: _requestSchedule.setShouldRequestIssues
    }, dispatch),
    updateHistory: () => {
      dispatch((0, _actionCreators.updateActionsUrlHistory)(ownProps.history.location, ownProps.history.action));
    },
    markAsMultiSite: () => dispatch((0, _selections.updateIsMultiSiteRoute)(true))
  };
}

class IssuesScene extends _react2.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "setActiveAction", actionId => {
      const {
        history
      } = this.props;

      const qs = _queryStringForAll.default.parse(history.location.search);

      const stringified = _queryStringForAll.default.stringify({ ...qs,
        action: actionId
      });

      history.replace({
        search: stringified
      });
      this.props.updateHistory();
    });
    (0, _defineProperty2.default)(this, "filterMonitoring", (status, data) => {
      let actionsByResponsible; // Split actions by whether they're assigned to the 'Monitoring' team

      if (status === 'monitoring') {
        actionsByResponsible = data.filter(action => action.responsible === 'Monitoring');
      } else {
        actionsByResponsible = data.filter(action => action.responsible !== 'Monitoring');
      } // Remove all actions with status 'Rejected'


      const filtered = actionsByResponsible.filter(action => action.bonfire_status !== 'Rejected');
      this.setState({
        filtered
      });
    });
    (0, _defineProperty2.default)(this, "handleChangeStatus", status => () => {
      const {
        history
      } = this.props;

      const qs = _queryStringForAll.default.parse(history.location.search); // Add the new urlParam closedOnStartDate when viewing closed actions,
      // default value for the urlParam is 12 (months)


      const stringified = status === _issues.ACTION_STATUSES.closed ? _queryStringForAll.default.stringify({ ...qs,
        action: undefined,
        status,
        closedOnStartDate: _issues.CLOSED_ACTIONS_START_DATE.LAST_12_MONTHS
      }) : _queryStringForAll.default.stringify({ ...qs,
        action: undefined,
        status,
        closedOnStartDate: undefined
      });
      history.replace({
        search: stringified
      });
      this.props.updateHistory();
    });
    (0, _defineProperty2.default)(this, "handleClosedActionsTimeFrameChange", option => {
      const {
        history
      } = this.props;

      const qs = _queryStringForAll.default.parse(history.location.search);

      const stringified = _queryStringForAll.default.stringify({ ...qs,
        action: undefined,
        closedOnStartDate: option
      });

      history.replace({
        search: stringified
      });
      this.props.updateHistory();
      this.props.setShouldRequestIssues(true);
      this.props.loadIssuesRequest(_issues.ACTION_STATUSES.closed, option);
    });
    this.state = {
      filtered: []
    };
  }

  componentDidMount() {
    const {
      appSetupComplete,
      issuesLoading,
      error,
      shouldRequestIssues,
      history,
      markAsMultiSite,
      data
    } = this.props;
    markAsMultiSite(); // If no status present in search params, default to 'open'

    const qs = _queryStringForAll.default.parse(history.location.search);

    const {
      status
    } = qs;

    if (!status) {
      const stringified = _queryStringForAll.default.stringify({ ...qs,
        status: _issues.ACTION_STATUSES.open
      });

      history.replace({
        search: stringified
      });
    }

    if (!appSetupComplete) return; // Populate the issues list if they've not yet been issuesLoaded

    if (status && !issuesLoading && !error && shouldRequestIssues) {
      this.props.loadIssuesRequest(status);
    } // HACK: This is a gross workaround for a half-baked requirement


    if (this.props.data) {
      this.filterMonitoring(status, data);
    }
  }
  /**
   * !!! TODO !!!
   * 1. Convert to typescript !!!
   * 2.`updateHistory` should now be redundant, as the UI
   *    can't get into a state where open/closed/monitoring
   *    is incompatible.
   * 3. See if some of the query string handling logic can
   *    be factored out into a utility
   */


  componentDidUpdate(prevProps) {
    const {
      appSetupComplete,
      issuesLoading,
      error,
      shouldRequestIssues,
      location
    } = this.props;

    const pastQS = _queryStringForAll.default.parse(prevProps.location.search);

    const currentQS = _queryStringForAll.default.parse(location.search);

    const pastStatus = pastQS.status;
    const currentStatus = currentQS.status;

    if (!error && shouldRequestIssues && !issuesLoading) {
      // this is handleing the request if the status is closed and sites changed
      if (currentStatus === _issues.ACTION_STATUSES.closed && currentQS.closedOnStartDate !== undefined) {
        // when closedOnStartDate appears as urlParam
        this.props.loadIssuesRequest(currentStatus, Number(currentQS.closedOnStartDate));
      } else {
        this.props.loadIssuesRequest(currentStatus);
      }
    } else if (currentStatus && pastStatus !== currentStatus && !prevProps.shouldRequestIssues) {
      this.props.setShouldRequestIssues(true);
    }

    if (currentQS.action && prevProps.appSetupComplete !== appSetupComplete) {
      this.props.updateHistory();
    }

    if (currentQS.action && pastQS.action !== currentQS.action) {
      this.props.updateHistory();
    }

    if (appSetupComplete && pastQS.sites !== currentQS.sites) {
      this.setActiveAction(undefined);
    }

    if (prevProps.data !== this.props.data) {
      this.filterMonitoring(currentStatus, this.props.data);
    }
  }
  /**
   * actionId can be a string or undefined
   */


  render() {
    const {
      user,
      appSetupComplete,
      issuesLoading,
      issuesLoaded,
      sortFilter,
      sortDirection,
      location,
      history,
      selectedSites
    } = this.props;

    if (!appSetupComplete) {
      return null;
    }

    const {
      action: activeActionId,
      status,
      closedOnStartDate
    } = _queryStringForAll.default.parse(location.search);

    if (!user.groups.includes('Bueno') && status === 'monitoring') {
      return /*#__PURE__*/_react2.default.createElement(_reactRouterDom.Redirect, {
        to: "/actions"
      });
    }

    return /*#__PURE__*/_react2.default.createElement(_context.ViewActionProvider, null, /*#__PURE__*/_react2.default.createElement(_reactHelmet.default, {
      title: "Actions"
    }), /*#__PURE__*/_react2.default.createElement(_blocks.SecondaryNav, {
      hasBottomBorder: true
    }, /*#__PURE__*/_react2.default.createElement(_blocks.Thirds, null, /*#__PURE__*/_react2.default.createElement(_blocks.Center, null, /*#__PURE__*/_react2.default.createElement(_blocks.SecondaryNavItem, {
      isActive: status === 'open',
      onClick: this.handleChangeStatus('open')
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "actions.open_actions"
    })), /*#__PURE__*/_react2.default.createElement(_blocks.SecondaryNavItem, {
      isActive: status === 'closed',
      onClick: this.handleChangeStatus('closed')
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "actions.closed_actions"
    })), user.groups.includes('Bueno') && /*#__PURE__*/_react2.default.createElement(_blocks.SecondaryNavItem, {
      isActive: status === 'monitoring',
      onClick: this.handleChangeStatus('monitoring'),
      "data-cy": "SecondaryNav-monitoringActions"
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "actions.monitoring_actions"
    }))))), /*#__PURE__*/_react2.default.createElement(_Page.Wrap, null, issuesLoading && !issuesLoaded ? /*#__PURE__*/_react2.default.createElement(_Loading.default, null) : /*#__PURE__*/_react2.default.createElement(ActionsContainer, null, /*#__PURE__*/_react2.default.createElement(_Issues.Actions, {
      activeActionId: activeActionId,
      data: this.state.filtered,
      setActiveAction: this.setActiveAction,
      userDisplayName: user.display_name,
      sortFilter: sortFilter,
      onActionUpdate: this.props.updateBetaIssue,
      sortDirection: sortDirection,
      updateHistory: this.props.updateHistory,
      history: history,
      status: status,
      numberOfSelectedSites: selectedSites.length,
      handleClosedActionsTimeFrameChange: this.handleClosedActionsTimeFrameChange,
      closedOnStartDate: closedOnStartDate === undefined ? closedOnStartDate : Number(closedOnStartDate)
    }), issuesLoading && /*#__PURE__*/_react2.default.createElement(ReloaderContainer, null, /*#__PURE__*/_react2.default.createElement(_Loading.default, null)))));
  }

}

(0, _defineProperty2.default)(IssuesScene, "propTypes", {
  error: _propTypes.default.object,
  loadIssuesRequest: _propTypes.default.func.isRequired,
  issuesLoaded: _propTypes.default.bool,
  issuesLoading: _propTypes.default.bool,
  sortFilter: _propTypes.default.string,
  data: _propTypes.default.array,
  selectedSites: _propTypes.default.array,
  markAsMultiSite: _propTypes.default.func.isRequired
});
(0, _defineProperty2.default)(IssuesScene, "defaultProps", {
  issuesLoading: false,
  issuesLoaded: false,
  data: [],
  sortFilter: 'UPDATED_NEWEST'
});

var _default = (0, _reactHotLoader.hot)(module)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IssuesScene)));

exports.default = _default;
module.exports = exports.default;